<div class="keyboard-wrapper" [class.visible]="visible$ | async">
  <div #keyboardContainer class="simple-keyboard"></div>
</div>
